module.exports = __webpack_public_path__ + "static/img/diners.add07a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards/diners.svg
// module id = dNi4
// module chunks = 1